import AccessToken from '~/Api/Authentication/AccessToken';
import mapAccessToken from '~/Api/Authentication/mapAccessToken';
import ApiClient from '~/ApiClient';

export interface Result {
	accessToken: AccessToken;
}

export default async function switchBack(client: ApiClient): Promise<Result> {
	const request = await client.fetch('authentication/impersonate/switch-back', {
		method: 'POST',
	});
	const response = await request.json();

	return { accessToken: mapAccessToken(response.accessToken) };
}
